import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export interface NonUsFinancialAccountsStateValues {
  whatAreFbarfinCen114Fatca8938AndWhoMustCompleteTheseDisclosureForms: Nullable<string>;
  atAnyTimeDuringYearDidYouOwnAFinancialAccountsuchAsBankSavingsRetirementOrBrokerageAccountOutsideTheUnitedStates: Nullable<TYesOrNo>;
  atAnyPointDuringYearWasTheSumAcrossAllYourNonUsFinancialAccountsOverUsd10000: Nullable<TYesOrNo>;
  howManyFinancialAccountsOutsideTheUSDidYouOwnOrHaveSignatoryAuthorityDuringTheFilingYear: Nullable<string>;
  doYouWantTfxToPrepareYourFbar: Nullable<TYesOrNo>;
  iHaveBeenAdvisedThatThoseWhoHaveNonUsFinancialAccountsValuedOver10000NeedToFileFormsFinCen114fbarAndorForm8938fatcaThereArePotentiallySevereConsequencesStemmingFromFailureToFileTheseFormsWithTheIrstreasury: Nullable<string>;
  whichOfTheFollowingBestDescribesYourFilingStatus: Nullable<string>;
  didYouHaveOver300000InNonUsFinancialAssetsDuringYear: Nullable<TYesOrNo>;
  didYouHaveOver200000AcrossAllNonUsAccountsOnDec31Year: Nullable<TYesOrNo>;
  didYouHaveOver600000InNonUsFinancialAssetsDuringYear: Nullable<TYesOrNo>;
  didYouHaveOver400000AcrossAllNonUsAccountsOnDec31Year: Nullable<TYesOrNo>;
  didYouHaveOver150000InNonUsFinancialAssetsDuringYear: Nullable<TYesOrNo>;
  didYouHaveOver100000AcrossAllNonUsAccountsOnDec31Year: Nullable<TYesOrNo>;
  didYouHaveOver75000InNonUsFinancialAssetsDuringYear: Nullable<TYesOrNo>;
  didYouHaveOver50000AcrossAllNonUsAccountsOnDec31Year: Nullable<TYesOrNo>;
  didYouOwnMoreThan50OfACorporationThatHasANonUsBankAccount: Nullable<TYesOrNo>;
  areYouAnOwnerfullOrPartialOfANonUsTrust: Nullable<TYesOrNo>;
  areYouABeneficiaryOfANonUsTrust: Nullable<TYesOrNo>;
  didYouReceiveSellSendExchangeOrOtherwiseAcquireAnyFinancialInterestInAnyVirtualCurrency: Nullable<TYesOrNo>;
}

export interface NonUsFinancialAccountsState {
  values: NonUsFinancialAccountsStateValues;
}

const initialState: NonUsFinancialAccountsState = {
  values: {
    whatAreFbarfinCen114Fatca8938AndWhoMustCompleteTheseDisclosureForms: null,
    atAnyTimeDuringYearDidYouOwnAFinancialAccountsuchAsBankSavingsRetirementOrBrokerageAccountOutsideTheUnitedStates:
      null,
    atAnyPointDuringYearWasTheSumAcrossAllYourNonUsFinancialAccountsOverUsd10000:
      null,
    howManyFinancialAccountsOutsideTheUSDidYouOwnOrHaveSignatoryAuthorityDuringTheFilingYear:
      null,
    doYouWantTfxToPrepareYourFbar: null,
    iHaveBeenAdvisedThatThoseWhoHaveNonUsFinancialAccountsValuedOver10000NeedToFileFormsFinCen114fbarAndorForm8938fatcaThereArePotentiallySevereConsequencesStemmingFromFailureToFileTheseFormsWithTheIrstreasury:
      null,
    whichOfTheFollowingBestDescribesYourFilingStatus: null,
    didYouHaveOver300000InNonUsFinancialAssetsDuringYear: null,
    didYouHaveOver200000AcrossAllNonUsAccountsOnDec31Year: null,
    didYouHaveOver600000InNonUsFinancialAssetsDuringYear: null,
    didYouHaveOver400000AcrossAllNonUsAccountsOnDec31Year: null,
    didYouHaveOver150000InNonUsFinancialAssetsDuringYear: null,
    didYouHaveOver100000AcrossAllNonUsAccountsOnDec31Year: null,
    didYouHaveOver75000InNonUsFinancialAssetsDuringYear: null,
    didYouHaveOver50000AcrossAllNonUsAccountsOnDec31Year: null,
    didYouOwnMoreThan50OfACorporationThatHasANonUsBankAccount: null,
    areYouAnOwnerfullOrPartialOfANonUsTrust: null,
    areYouABeneficiaryOfANonUsTrust: null,
    didYouReceiveSellSendExchangeOrOtherwiseAcquireAnyFinancialInterestInAnyVirtualCurrency:
      null,
  },
};

const nonUsFinancialAccountsSlice = createSlice({
  name: 'nonUsFinancialAccounts',
  initialState,
  reducers: {
    update(state, action: PayloadAction<NonUsFinancialAccountsStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof NonUsFinancialAccountsStateValues;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.nonUsFinancialAccounts
              .nonUsFinancialAccounts.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey } = nonUsFinancialAccountsSlice.actions;
export default nonUsFinancialAccountsSlice.reducer;

export const selectNonUsFinancialAccounts = (state: RootState) =>
  state.taxQuestionnaire.nonUsFinancialAccounts.nonUsFinancialAccounts;
